import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from '../design-system'
import { ArrowLeft, RotateCcw } from 'lucide-react'

const ResultsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">
            Test Results
          </h1>
          
          <div className="bg-white rounded-lg shadow-sm p-8 mb-8">
            <p className="text-gray-600 mb-4">
              Complete a test to see your results here
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/test">
              <Button className="w-full sm:w-auto">
                <RotateCcw className="mr-2 w-4 h-4" />
                Take Test
              </Button>
            </Link>
            <Link to="/">
              <Button variant="outline" className="w-full sm:w-auto">
                <ArrowLeft className="mr-2 w-4 h-4" />
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResultsPage